import React from "react";
import Skeleton from "react-loading-skeleton";

export function EventLoader({items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
    <div key={i} className="myk-calendar-skeleton information-block p-0 py-0 mb-0">
        <div className="information-wrap">
            <div className="information-holder align-items-center gap-2 px-3 py-2">
                <Skeleton style={{borderRadius: "13%"}} width={'88px'} height={'50px'} />
                <div className="information-detail">
                <h3 style={{marginBottom: "10px"}}><Skeleton width={'50%'} height={'8px'} /></h3>
                <p><Skeleton width={'80%'} height={'10px'} /></p>
                </div>
                <Skeleton style={{borderRadius: "42px"}} width={'80px'} height={'20px'} />
            </div>
        </div>
    </div>
    );
  }
  return (
    <div className="eventlist-all">
        <div className="eventlist-date-group myk-event-skeleton-group">
            {viewRender}
        </div>
    </div>
  )
}

export default { EventLoader };
